import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__wave">
        <svg viewBox="0 0 1440 120" preserveAspectRatio="none">
          <path d="M0,60 C360,120 1080,0 1440,60 L1440,120 L0,120 Z" fill="#0a1e0f" />
        </svg>
      </div>

      <div className="footer__body">
        <div className="container">
          <div className="footer__grid">
            <div className="footer__brand">
              <div className="footer__logo">
                <span className="footer__logo-icon">🌍</span>
                <div>
                  <div className="footer__logo-name">Y2K Global Nexus</div>
                  <div className="footer__logo-url">calltree.in</div>
                </div>
              </div>
              <p className="footer__tagline">
                Every tree planted is a memory made — for loved ones, for the planet, for generations yet to come.
              </p>
              <div className="footer__social">
                <a href="#" aria-label="Facebook" className="footer__social-link">f</a>
                <a href="#" aria-label="Instagram" className="footer__social-link">ig</a>
                <a href="#" aria-label="Twitter" className="footer__social-link">tw</a>
                <a href="#" aria-label="YouTube" className="footer__social-link">yt</a>
              </div>
            </div>

            <div className="footer__links">
              <h4>Explore</h4>
              <Link to="/">Home</Link>
              <Link to="/about">About Y2K</Link>
              <Link to="/calltree">CallTree Project</Link>
              <Link to="/activities">Activities</Link>
              <Link to="/agri-products">Agri Products</Link>
              <Link to="/contact">Join Us</Link>
            </div>

            <div className="footer__links">
              <h4>Initiatives</h4>
              <a href="#">Plant a Love Tree</a>
              <a href="#">Forest Dept. Partnership</a>
              <a href="#">Climate Awareness Drive</a>
              <a href="#">Clean India Mission</a>
              <a href="#">Global Expansion</a>
            </div>

            <div className="footer__contact">
              <h4>Get in Touch</h4>
              <p>🌐 calltree.in</p>
              <p>📧 info@calltree.in</p>
              <p>🤝 In association with Forest Department</p>
              <div className="footer__cert">
                <span>NGO Registered</span>
                <span>Forest Dept. Certified</span>
              </div>
            </div>
          </div>

          <div className="footer__bottom">
            <p>© 2025 Y2K Global Nexus | calltree.in — All Rights Reserved</p>
            <p>Made with 🌱 for a greener world</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
